export enum BillingsOrderForwardTaxiTaxiDraftContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiDraftBonusContributionFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftBonusContributionOther = {
  type: BillingsOrderForwardTaxiTaxiDraftContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiDraftPenaltyContributionWrongRoute = {
  type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiDraftPenaltyContributionBeingLate = {
  type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiDraftPenaltyContributionIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftPenaltyContributionOther = {
  type: BillingsOrderForwardTaxiTaxiDraftContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiDraftBonusContribution =
  | BillingsOrderForwardTaxiTaxiDraftBonusContributionFavorableDistance
  | BillingsOrderForwardTaxiTaxiDraftBonusContributionOther;

export type BillingsOrderForwardTaxiTaxiDraftPenaltyContribution =
  | BillingsOrderForwardTaxiTaxiDraftPenaltyContributionWrongRoute
  | BillingsOrderForwardTaxiTaxiDraftPenaltyContributionBeingLate
  | BillingsOrderForwardTaxiTaxiDraftPenaltyContributionIncompatibleCar
  | BillingsOrderForwardTaxiTaxiDraftPenaltyContributionOther;

export type BillingsOrderForwardTaxiTaxiDraftContribution =
  | BillingsOrderForwardTaxiTaxiDraftBonusContribution
  | BillingsOrderForwardTaxiTaxiDraftPenaltyContribution;

export type BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContractProducerTaxi =
  {
    displayName: string;
  };

export type BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrderCargoOrder =
  {
    uuid: string;
    humanId: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrder =
  {
    cargoOrder: BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrderCargoOrder;
  };

export type BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContract = {
  model: string;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxi: BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContractProducerTaxi;
};

export type BillingsOrderForwardTaxiTaxiDraftOrderForwardingAction = {
  uuid: string;
  contract: BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionContract;
  transportingOrder: BillingsOrderForwardTaxiTaxiDraftOrderForwardingActionTransportingOrder;
};

export type BillingsOrderForwardTaxiTaxiDraftBillingNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: string | null;
  checkoutEventUuid: string | null;
  plannedDate: string | null;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

type BillingsOrderForwardTaxiTaxiDraft = {
  orderForwardingAction: BillingsOrderForwardTaxiTaxiDraftOrderForwardingAction;
  billingNodes: BillingsOrderForwardTaxiTaxiDraftBillingNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiDraftContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryUuid: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  passengers: string[];
};

export default BillingsOrderForwardTaxiTaxiDraft;
